import { Theme } from '@mui/material/styles';
import { primaryFont } from '../../typography';

export default function CssBaseline(theme: Theme) {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
        },
        '#root, #__next': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              // WebkitAppearance: 'none',
              margin: 0,
              width: theme.spacing(2),
              height: theme.spacing(2),
            },
            '&::-webkit-inner-spin-button': {
              // WebkitAppearance: 'none',
              width: theme.spacing(2),
              height: theme.spacing(2),
              margin: 0,
            },
          },
        },
        img: {
          maxWidth: '100%',
          display: 'inline-block',
          verticalAlign: 'bottom',
        },
        textarea: {
          fontFamily: primaryFont,
          fontSize: theme.typography.body3.fontSize,
          padding: theme.spacing(1, 1.5),
          borderRadius: theme.spacing(1),
          border: `1px solid ${theme.palette.grey[300]}`,
          resize: 'none',

          '&::placeholder': {
            color: theme.palette.grey[400],
            fontFamily: primaryFont,
            fontSize: theme.typography.body3.fontSize,
          },
        },
      },
    },
  };
}
